module.exports = __webpack_public_path__ + "media/softinyalms-tr.78d80e58.mp4";